<script lang="ts">
  // Renders an activity/workout attached to a message/comment. Only {type, path} is ever stored on
  // the message itself (see ExerciseAttachment in ./api) -- the full card data is fetched fresh
  // here so it always reflects the activity/workout's current state, and so a viewer who isn't
  // authorized to see it (or one that's since been deleted) just gets an "unavailable" card rather
  // than stale/leaked data baked into the message.
  import { onMount } from 'svelte';
  import { getExerciseSummary } from '@/Util/api';
  import type { Exercise } from '@/Common/ActivityFunctions';
  import TrainingCardSquare from '@/MyFitness/Today/TrainingCardSquare.svelte';
  import Card from '@/lib/components/ui/card/card.svelte';

  export let type: 'activity' | 'workout';
  export let path: string;

  let exercise: Exercise | null = null;
  let loading = true;

  onMount(async () => {
    try {
      exercise = await getExerciseSummary(type, path);
    } finally {
      loading = false;
    }
  });
</script>

{#if loading}
  <div class="flex h-24 w-48 items-center justify-center rounded-md border border-border text-xs text-muted-foreground">Loading…</div>
{:else if !exercise}
  <div class="flex h-24 w-48 items-center justify-center rounded-md border border-border text-xs text-muted-foreground">
    {type === 'activity' ? 'Activity' : 'Workout'} unavailable
  </div>
{:else}
  <Card class="w-fit border-border p-[8px] pt-[12px]">
    <TrainingCardSquare {exercise} size="sm" />
  </Card>
{/if}
